import React, { useEffect, useState } from 'react';
import particularesApiService from '../../services/ParticularesApiService';
import { formatPorcentaje, formatPromedio, normalizeEstadoAcademicoCuenta } from '../../utils/evaluaciones';
import './EstadoAcademico.css';

// Resumen para la pantalla de inicio: indicadores de notas y asistencia y las alertas principales
// (alumnos en riesgo, baja asistencia, ausencias seguidas). "onVerTodo" abre el estado académico completo.

const MAX_ALERTAS = 6;

const ICONOS = {
  academica: 'fa-graduation-cap',
  asistencia: 'fa-user-clock',
  ausencias: 'fa-calendar-times'
};

const EstadoAcademicoResumen = ({ titulo = 'Situación de tus alumnos', onVerTodo }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    particularesApiService.getEstadoAcademico()
      .then((response) => active && setData(normalizeEstadoAcademicoCuenta(response?.academico || response?.Academico || {})))
      .catch((err) => active && setError(err?.message || 'No pudimos cargar la situación de los alumnos.'));
    return () => {
      active = false;
    };
  }, []);

  if (error) {
    return <section className="ea-panel ea-resumen"><p className="ea-error">{error}</p></section>;
  }

  if (!data) {
    return (
      <section className="ea-panel ea-resumen">
        <div className="ea-empty"><i className="fas fa-spinner fa-spin" aria-hidden="true" /> Cargando situación de los alumnos...</div>
      </section>
    );
  }

  const conAsistencia = data.modoColegio && data.totales.tieneAsistencias;
  const alertas = data.alertas.slice(0, MAX_ALERTAS);

  return (
    <section className="ea-panel ea-resumen">
      <header className="ea-header">
        <div>
          <h2><i className="fas fa-heartbeat" aria-hidden="true" /> {titulo}</h2>
          <p>Notas y asistencia de {data.totales.totalAlumnos} {data.totales.totalAlumnos === 1 ? 'alumno' : 'alumnos'} en {data.totales.totalCursos} {data.totales.totalCursos === 1 ? 'curso' : 'cursos'}.</p>
        </div>
        {onVerTodo && (
          <button type="button" className="ea-btn" onClick={onVerTodo}>
            <i className="fas fa-chart-bar" aria-hidden="true" />
            Ver estado académico
          </button>
        )}
      </header>

      <div className="ea-kpis">
        <article className="ea-kpi ea-kpi-primary">
          <i className="fas fa-chart-line" aria-hidden="true" />
          <div><span>Promedio general</span><strong>{formatPromedio(data.totales.promedioGeneral)}</strong></div>
        </article>
        <article className="ea-kpi ea-kpi-danger">
          <i className="fas fa-exclamation-circle" aria-hidden="true" />
          <div><span>En riesgo por notas</span><strong>{data.totales.alumnosEnRiesgo}</strong></div>
        </article>
        {conAsistencia && (
          <article className="ea-kpi ea-kpi-primary">
            <i className="fas fa-user-clock" aria-hidden="true" />
            <div><span>Asistencia promedio</span><strong>{formatPorcentaje(data.totales.porcentajeAsistencia)}</strong></div>
          </article>
        )}
        <article className={`ea-kpi ${data.totales.alumnosConAlertas > 0 ? 'ea-kpi-danger' : 'ea-kpi-success'}`}>
          <i className="fas fa-bell" aria-hidden="true" />
          <div><span>Alumnos con alertas</span><strong>{data.totales.alumnosConAlertas}</strong></div>
        </article>
      </div>

      {data.alertas.length === 0 ? (
        <p className="ea-sin-alertas"><i className="fas fa-check-circle" aria-hidden="true" /> No hay alertas: ningún alumno en riesgo ni con baja asistencia.</p>
      ) : (
        <ul className="ea-alertas-lista">
          {alertas.map((alerta, index) => (
            <li key={`${alerta.idAlumno}-${alerta.tipo}-${index}`} className={`ea-alerta-${alerta.severidad}`}>
              <i className={`fas ${ICONOS[alerta.tipo] || 'fa-exclamation-circle'}`} aria-hidden="true" />
              <div>
                <strong>{alerta.alumnoNombre}</strong>
                {alerta.divisiones && <small>{alerta.divisiones}</small>}
                <span>{alerta.mensaje}</span>
              </div>
            </li>
          ))}
          {data.alertas.length > MAX_ALERTAS && (
            <li className="ea-alertas-mas">
              y {data.alertas.length - MAX_ALERTAS} {data.alertas.length - MAX_ALERTAS === 1 ? 'alerta más' : 'alertas más'}
              {onVerTodo && <button type="button" className="ea-link" onClick={onVerTodo}>Ver todas</button>}
            </li>
          )}
        </ul>
      )}
    </section>
  );
};

export default EstadoAcademicoResumen;
